enum InvoiceOperation {
    CANCELLATION = "CANCELLATION",
    CORRECTION = "CORRECTION",
  }
  
  export default InvoiceOperation;